import { v4 as uuidv4 } from 'uuid'

export default {
  createUUID() {
    return uuidv4().toUpperCase()
  }
}
